const doc = [({"en":({"js":({"admin":({"sending_rules":({"create_card":({"create_sending_rule":"Create sending rule"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;